module.exports = __webpack_public_path__ + "a13060dd9183a2239c4531a9daeefb3e.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../images/speakers/small/sarrah-vesselov.jpg
// module id = 678
// module chunks = 0